import React, { Component } from "react";

export class DatePicker extends Component {
  updateDate(change) {
    var date = Object.assign(this.props.date, change);
    this.props.updateDate(date);
  }

  render() {
    return (
      <div className="form-group">
        <label htmlFor={this.props.id + "Day"}>{this.props.label}</label>
        {this.props.desc ? <p>{this.props.desc}</p> : null}
        <div className="custom-select-group">
          <select
            id={this.props.id + "Day"}
            name={this.props.id + "Day"}
            className="custom-select form-control"
            value={this.props.date.day}
            onChange={event => this.updateDate({ day: event.target.value })}
          >
            <option disabled="">Day</option>
            {Array.from(Array(32).keys())
              .splice(1)
              .map(day => {
                return (
                  <option value={("0" + day).substr(-2)} key={day}>
                    {("0" + day).substr(-2)}
                  </option>
                );
              })}
          </select>
           {this.props.mfa? "" : <span className="p-2">/</span>}
          <select
            id={this.props.id + "Month"}
            name={this.props.id + "Month"}
            className="custom-select form-control"
            value={this.props.date.month}
            onChange={event => this.updateDate({ month: event.target.value })}
          >
            <option disabled="">Month</option>
            <option value="00">January</option>
            <option value="01">February</option>
            <option value="02">March</option>
            <option value="03">April</option>
            <option value="04">May</option>
            <option value="05">June</option>
            <option value="06">July</option>
            <option value="07">August</option>
            <option value="08">September</option>
            <option value="09">October</option>
            <option value="10">November</option>
            <option value="11">December</option>
          </select>
          {this.props.mfa? "" : <span className="p-2">/</span>}
          <select
            id={this.props.id + "Year"}
            name={this.props.id + "Year"}
            className="custom-select form-control"
            value={this.props.date.year}
            onChange={event => this.updateDate({ year: event.target.value })}
          >
            <option disabled="">Year</option>
            {Array.from(Array(parseInt(this.props.numYears, 10) + 2).keys())
              .splice(1 + parseInt(this.props.ageOffset, 10))
              .map(year => {
                return (
                  <option key={year}>
                    {new Date().getFullYear() - year + 1}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    );
  }
}

export default DatePicker;
